/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';


@Component({
    selector: 'basic-payment-list',
    templateUrl: './payment-list.component.html',
    styleUrls: ['./payment-list.component.scss'],
    standalone: false,
})
export class BasicPaymentListComponent {

   @Input() payments = [];


  displayedColumns: string[] = [
    'description',
    'paymentAmount',
    'paymentDate',

  ];

  get getTotalAmount(): number {
    let total = 0;
    this.payments.forEach((payment: any) => {
      total += payment.amount;
    });
    return total;
  }

}